module.exports = __webpack_public_path__ + "static/open-source-bg-e0b86189922580cc929a327c89d917dc.jpg";